import { PropertyChange } from "../BaseCommandHandler";

export const FAINT_COLORS: Record<string, string> = {
  green: '#8fa67d',
  blue: '#e6f2f7',
  orange: '#fae8dc',
  default: '#f5f5f5',
};

export const RADIUS_PRESETS: Record<string, string> = {
  none: '0px',
  xs: '2px',
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  '2xl': '24px',
  full: '9999px',
};

export const BORDER_WIDTHS: Record<string, string> = {
  thin: '1px',
  medium: '2px',
  thick: '3px',
  heavy: '4px',
};

export const DEFAULT_BORDER_COLOR = '#e5e7eb';

export const SHADOW_PRESETS: Record<string, string> = {
  none: 'none',
  xs: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  sm: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  '2xl': '0 25px 50px -12px rgb(0 0 0 / 0.25)',
};

export const INSET_SHADOW_PRESETS: Record<string, string> = {
  sm: 'inset 0 1px 2px 0 rgb(0 0 0 / 0.05)',
  md: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.1)',
  lg: 'inset 0 4px 8px 0 rgb(0 0 0 / 0.15)',
};

export const ELEVATION_MAP = ['none', 'xs', 'sm', 'md', 'lg', 'xl'];

export const STYLE_PRESETS: Record<string, PropertyChange> = {
  card: {
    properties: { padding: 24, borderRadius: 8 },
    style: {
      backgroundColor: '#ffffff',
      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    },
  },
  panel: {
    properties: { padding: 16, borderRadius: 4 },
    style: {
      backgroundColor: '#f9fafb',
      border: '1px solid #e5e7eb',
    },
  },
  outlined: {
    properties: { borderRadius: 8 },
    style: {
      backgroundColor: 'transparent',
      border: '1px solid #e5e7eb',
    },
  },
  elevated: {
    properties: { borderRadius: 12 },
    style: {
      backgroundColor: '#ffffff',
      boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    },
  },
};
